import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SecretariesSettingsAdapter } from 'app/core/adapters/secretaries-settings.adapter';
import { SecretarySettings } from 'app/core/interfaces/secretaries-settings';
import { environment } from 'app/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SecretariesSettingsService {
  constructor(
    private http: HttpClient,
    private secretarySettingsAdapter: SecretariesSettingsAdapter,
  ) {}

  create(secretarySettings: SecretarySettings): Observable<SecretarySettings> {
    const secretarySettingsAPI = this.secretarySettingsAdapter.adaptToAPIFormat(secretarySettings);

    return this.http
      .post<SecretarySettings>(`${environment.apiUrl}/secretarias-secretaries-settings`, secretarySettingsAPI)
      .pipe(map((secretarySettings: SecretarySettings) => this.secretarySettingsAdapter.adapterToModel(secretarySettings)));
  }

  update(secretarySettings: SecretarySettings, secretary_settings_id: string): Observable<SecretarySettings> {
    const secretarySettingsAPI = this.secretarySettingsAdapter.adaptToAPIFormat(secretarySettings);

    return this.http
      .put<SecretarySettings>(`${environment.apiUrl}/secretarias-secretaries-settings/${secretary_settings_id}`, secretarySettings)
      .pipe(map((secretarySettings: SecretarySettings) => this.secretarySettingsAdapter.adapterToModel(secretarySettings)));
  }

  createOnboarding(secretary_id: string, recipient_id: string, secretary_settings_id?: string) {
    return this.http.post<SecretarySettings['onboard_qrcode']>(
      `${environment.apiUrl}/secretarias-secretaries-settings/secretaries/${secretary_id}/recipients/${recipient_id}`,
      { secretary_settings_id },
    );
  }

  findBySecretary(secretary_id: string): Observable<SecretarySettings> {
    return this.http
      .get<SecretarySettings[]>(`${environment.apiUrl}/secretarias-secretaries-settings/secretaries/${secretary_id}`)
      .pipe(map((secretarySettingsAPI: SecretarySettings[]) => this.secretarySettingsAdapter.adapterToModel(secretarySettingsAPI[0])));
  }
}
